export default __webpack_public_path__ + "static/media/photo--lg--124.21f33731.jpg";